/**
 * Contains logic to switch between native and wrapped currencies
 */
import BigNumber from 'bignumber.js';
import { ICoin } from '../reducers/tradingReducer';

enum Chain {
  ETH = 1,
  BSC = 56,
  POLYGON = 137,
  FTM = 250,
  AVAX = 43114,
  ELROND = 999999,
  OPTIMISM = 10,
}

const BASE_TOKEN = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';

const SUPPORTED_CHAINS = [
  Chain.ETH,
  Chain.BSC,
  Chain.POLYGON,
  Chain.FTM,
  Chain.AVAX,
];

const Native_Coin = (name: string, amount: BigNumber) => ({
  name,
  amount,
  symbol: name,
  decimals: 18,
  address: BASE_TOKEN,
});

export const NativeCoin = (chainId: number, amount: BigNumber): ICoin => {
  switch (chainId) {
  case Chain.ETH:
    return Native_Coin('ETH', amount);
  case Chain.BSC:
    return Native_Coin('BNB', amount);
  case Chain.POLYGON:
    return Native_Coin('MATIC', amount);
  case Chain.FTM:
    return Native_Coin('FTM', amount);
  case Chain.AVAX:
    return Native_Coin('AVAX', amount);
  case Chain.ELROND:
    return Native_Coin('EGLD', amount);
  case Chain.OPTIMISM:
    return Native_Coin('ETH', amount);
  default:
    return Native_Coin('MATIC', amount);
  }
};

export {
  BASE_TOKEN,
  SUPPORTED_CHAINS,
};
